<template>
  <div>
    <el-select v-model="val" placeholder="请选择" @change="change" :disabled="disabled">
      <el-option v-if="showAll" label="全部" value></el-option>
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "selector",
  props: {
    type: {
      type: String
    },
    value: {
      type: [String, Number],
      default: ""
    },
    showAll: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      options: []
    };
  },
  computed: {
    ...mapState(["selector"])
  },
  watch: {
    selector: {
      handler() {
        this.options = this.selector[this.type];
      }
    },
    value: {
      immediate: true,
      handler(val) {
        this.val = val;
      }
    }
  },
  mounted() {
    const options = this.selector[this.type];
    if (!options) {
      this.getSelector();
    } else {
      this.options = options;
    }
  },
  methods: {
    ...mapActions(["getSelector"]),
    change(value) {
      this.$emit("update:value", this.val);
    }
  }
};
</script>

<style scoped>
.select {
  margin-left: 10px;
}
</style>
